/* eslint-disable no-dupe-keys */
export default {
  header: {
    home: 'Home',
    history: 'History',
    suppliers: 'Suppliers',
    shop: 'Shop',
    career: 'Career',
    contactUs: 'Contact us',
    callUsToday: 'Call us today',
    chatWithUs: 'Communicate with us',
    signIn: 'Sign In',
    search: 'Search',
    searchPlaceholder: 'Search products...',
    searchProducts: 'Search Products',
    close: 'Close',
    greeting: 'Hello',
    logout: 'Logout',
    myAccount: 'My Account',
    noProductsFound: 'No products found',
    tryAnotherSearch: 'Try searching with different terms'
  },
  auth: {
    signIn: 'SIGN IN',
    signUp: 'SIGN UP',
    email: 'Email',
    username: 'Username',
    password: 'Password',
    forgotPassword: 'Forgot your password?',
    dontHaveAccount: "Don't have an account yet?",
    signUpFree: 'Sign Up for free',
    firstName: 'First Name',
    lastName: 'Last Name',
    confirmPassword: 'Confirm Password',
    create: 'CREATE',
    alreadyHaveAccount: 'Already have an account?',
    forgotPasswordTitle: 'FORGOT PASSWORD',
    forgotPasswordInstruction: 'Enter your email address and we will send you a link to reset your password.',
    sendResetLink: 'SEND RESET LINK',
    backToLogin: 'Back to Login',
    resetLinkSent: 'Password reset link has been sent to your email.',
    resetLinkError: 'Error sending reset link. Please try again.',
    emailRequired: 'Email is required',
    resetPasswordTitle: 'RESET PASSWORD',
    newPassword: 'New Password',
    resetPassword: 'RESET PASSWORD',
    allFieldsRequired: 'Please fill in all required fields',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordResetSuccess: 'Password reset successful. Redirecting to login...',
    passwordResetError: 'Error resetting password. Please try again.',
    signupError: 'Error creating account. Please try again.',
    loading: 'Loading...',
    signupSuccess: 'Account created successfully! Welcome!',
    firstNamePlaceholder: 'Enter your first name',
    lastNamePlaceholder: 'Enter your last name',
    emailPlaceholder: 'Enter your email',
    usernamePlaceholder: 'Enter your username',
    passwordPlaceholder: 'Enter your password',
    confirmPasswordPlaceholder: 'Confirm your password',
    fieldRequired: 'This field is required',
    signup: 'SIGN UP',
    invalidCredentials: 'Invalid credentials',
    loginError: 'Login error. Please try again.',
    noProjectsTitle: 'Access Denied',
    noProjectsMessage: 'You do not have any projects associated with your account and cannot access the system.',
    noProjectsContact: 'Please contact the administrator to request access to a project.',
    understood: 'Understood',
    passwordTooShort: 'Password must be at least 6 characters long',
    selectProject: 'Select a Project',
    project: 'Project',
    selectProjectPlaceholder: 'Select a project',
    location: 'Branch',
    selectLocationPlaceholder: 'Select a branch',
    confirm: 'CONFIRM',
    close: 'CLOSE',
    noProjectsFound: 'No projects found for this user.',
    loadingProjects: 'Loading projects...',
    projectLoadError: 'Error loading projects. Please try again.',
    locationLoadError: 'Error loading branches. Please try again.',
    retry: 'Retry',
    selectLocation: 'Select a Branch',
    selectLocationToContinue: 'Please select a branch to continue.'
  },
  cart: {
    checkout: 'CHECKOUT',
    subtotal: 'SUBTOTAL',
    taxesAndShipping: 'Taxes and shipping calculated at checkout',
    orderSummary: 'ORDER SUMMARY',
    shipping: 'Shipping',
    total: 'TOTAL',
    viewCart: 'VIEW CART',
    close: 'Close',
    decrease: 'Decrease quantity',
    increase: 'Increase quantity',
    remove: 'Remove item',
    addToCart: 'ADD',
    addCart: 'ADD TO CART',
    quantity: 'Quantity',
    productAdded: "Product added to cart successfully!",
    emptyCart: "Your shopping cart is empty",
    freeShipping: "Free Shipping"
  },
  shoppingCart: {
    title: 'SHOPPING CART',
    subtotal: 'SUBTOTAL',
    taxesAndShipping: 'Taxes and shipping calculated at checkout',
    checkout: 'CHECKOUT',
    product: 'Product',
    addNotes: 'Add Notes',
    notesPlaceholder: 'Add your notes here...',
    quantity: 'Quantity',
    total: 'TOTAL',
    continueShopping: "CONTINUE SHOPPING"
  },
  categories: {
    shopByCategories: 'SHOP BY CATEGORIES',
    title: 'CATEGORIES',
    price: 'PRICE',
    brands: 'BRANDS',
    sortBy: {
      featured: 'Sort by Featured',
      priceLowHigh: 'Price: Low to High',
      priceHighLow: 'Price: High to Low',
      nameAZ: 'Name: A to Z',
      nameZA: 'Name: Z to A'
    },
    showing: 'Showing {count} results'
  },
  hero: {
    bestShop: 'Your Best Online Shop',
    specialOffers: 'Special Offers',
    newCollection: 'New Collection',
    shopNow: 'Shop Now'
  },
  products: {
    newProducts: 'NEW PRODUCTS',
    outOfStock: 'Out of Stock',
    price: 'Price',
    // eslint-disable-next-line no-dupe-keys
    description: 'Description',
    noProductsFound: 'No products found',
    priceOnRequest: 'Price on request',
    priceToConsult: 'Price on request'
  },
  productSearch: {
    title: 'Add Products to Cart',
    searchPlaceholder: 'Search products to add to cart...',
    noResults: 'No products found. Try another search.',
    addToCart: 'Add'
  },
  common: {
    previous: 'Previous',
    next: 'Next',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    save: 'Save',
    update: 'Update',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    back: 'Back',
    saving: 'Saving...',
    updating: 'Updating...',
    deleting: 'Deleting...',
    retry: 'Retry',
    myAccount: 'My Account'
  },
  checkout: {
    calculating: "Calculating",
    processing: "Processing",
    errorCalculating: "Error calculating values",
    errorProcessingOrder: "Error processing order",
    emptyCart: "Your cart is empty",
    continueShopping: "CONTINUE SHOPPING",
    completePurchase: "COMPLETE ORDER",

    title: 'CHECKOUT',
    poNumber: 'P.O. Number',
    poNumberPlaceholder: 'Enter P.O. number...',
    contactOnSite: 'Contact on Site',
    contactOnSitePlaceholder: 'Enter contact name on site...',
    contactPhone: 'Contact Phone',
    contactPhonePlaceholder: 'Enter contact phone number...',
    deliveryDate: 'Delivery Date',
    deliveryDatePlaceholder: 'Select delivery date...',
    pickupDate: 'Pickup Date',
    pickupDatePlaceholder: 'Select pickup date...',
    specialInstructions: 'Special Delivery Instructions',
    specialInstructionsPlaceholder: 'Enter any special delivery instructions...',
    specialInstructionsPickup: 'Special Pick-up Instructions',
    specialInstructionsPlaceholderPickup: 'E.g., pickup time window, vehicle type, loading area...',
    landmark: 'Landmark',
    landmarkPlaceholder: 'Enter a landmark...',
    location: 'Order Location',
    selectLocation: 'Select location',
    deliveryMethod: 'Delivery Method',
    delivery: 'Delivery',
    pickup: 'Pick-up',
    pickupDisabledNoProject: 'Pickup requires an associated project',
    pickupRequiresProject: 'Pickup is only available for clients with an associated project',
    companyAddresses: 'Company Addresses',
    selectCompanyAddress: 'Select an address',
    useThisAddress: 'Use this address',
    personalDetails: 'Personal Details',
    firstName: 'First Name',
    firstNamePlaceholder: 'Enter your first name...',
    lastName: 'Last Name',
    lastNamePlaceholder: 'Enter your last name...',
    email: 'Email',
    emailPlaceholder: 'Enter your email...',
    phone: 'Phone',
    phonePlaceholder: 'Enter your phone number...',

    shippingDetails: 'Shipping Details',
    address: 'Address Line 1',
    addressPlaceholder: 'Enter your address...',
    number: 'Number',
    numberPlaceholder: 'Enter the number...',
    apartment: 'Additional Info',
    apartmentPlaceholder: 'Enter additional info...',
    city: 'City',
    cityPlaceholder: 'Enter your city...',
    state: 'State/Province',
    statePlaceholder: 'Select your state/province...',
    postalCode: 'Postal Code',
    postalCodePlaceholder: 'Enter your postal code...',
    country: 'Country',
    countryPlaceholder: 'Select your country...',
    selectCountry: 'Select country',
    selectState: 'Select state',
    errorLoadingCountries: 'Error loading countries',
    errorLoadingStates: 'Error loading states',
    invalidDate: 'Invalid date. Please select a valid date (starting from tomorrow)',
    landmark: 'Address Line 2',
    landmarkPlaceholder: 'Enter additional address information...',

    paymentDetails: 'Payment Details',
    cardHolder: 'Card Holder',
    cardHolderPlaceholder: 'Full name on card...',
    cardNumber: 'Card Number',
    cardNumberPlaceholder: 'Enter card number...',
    expiryDate: 'Expiry Date',
    expiryDatePlaceholder: 'MM/YY',
    cvv: 'CVV',
    cvvPlaceholder: '123',

    summary: {
      title: "ORDER SUMMARY",
      taxes: "TAXES",
      shipping: "SHIPPING",
      total: "TOTAL",
      freeShipping: "Free Shipping"
    },
    errorLoadingAddress: 'Error loading default address',
    errorLoadingLocations: 'Error loading locations',
    selectLocation: 'Select location',
    location: 'Location',
    pickupLocation: 'Pickup Location',
    changeLocation: 'Change location',
    useThisLocation: 'Use this location',
    noLocationsFound: 'No locations found',
    completePurchase: 'COMPLETE ORDER',
    fieldRequired: 'This field is required',
    changeAddress: 'Change address',
    selectAddress: 'Select delivery address',
    useThisAddress: 'Use this address',
    manageAddresses: 'Manage addresses',
    neighborhood: 'Neighborhood',
    neighborhoodPlaceholder: 'Enter your neighborhood',
    minOrderValueMessage: 'Minimum order value is {value}. Please add more items to your cart.',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    firstNamePlaceholder: 'Enter your first name',
    lastNamePlaceholder: 'Enter your last name',
    emailPlaceholder: 'Enter your email',
    phonePlaceholder: 'Enter your phone number',
    addressLine1: 'Address Line 1',
    addressLine1Placeholder: 'Enter street address',
    addressLine2: 'Address Line 2',
    addressLine2Placeholder: 'Enter additional address information',
    city: 'City',
    cityPlaceholder: 'Enter city',
    state: 'State',
    statePlaceholder: 'Enter state',
    postalCode: 'Postal Code',
    postalCodePlaceholder: 'Enter postal code',
    country: 'Country',
    countryPlaceholder: 'Enter country',
    contactOnSite: 'Contact on Site',
    contactOnSitePlaceholder: 'Enter contact name',
    contactPhone: 'Contact Phone',
    contactPhonePlaceholder: 'Enter contact phone',
    deliveryDate: 'Delivery Date',
    shippingDetails: 'Shipping Details',
    confirmProject: {
      title: 'Project Confirmation',
      message: 'You are completing the order for project:',
      confirm: 'Confirm and Continue',
      changeProject: 'Select Another Project',
      applyChange: 'Apply Change',
      noProjectsFound: 'No projects found for this user.',
      loadingProjects: 'Loading projects...',
      loadError: 'Error loading projects. Please try again.',
      retry: 'Retry'
    },
    confirmLocation: {
      message: 'And for branch:',
      changeLocation: 'Select Another Branch',
      applyChange: 'Apply Change',
      loadingLocations: 'Loading branches...',
      loadError: 'Error loading branches. Please try again.',
      retry: 'Retry',
      noLocationsFound: 'No branches found.'
    }
  },
  thankYou: {
    title: 'THANK YOU FOR YOUR ORDER!',
    orderNumber: 'Order #',
    emailConfirmation: "We've sent a confirmation email to your inbox with all the details of your purchase.",
    continueShopping: 'CONTINUE SHOPPING'
  },
  footer: {
    titles: {
      products: 'PRODUCTS',
      contactUs: 'CONTACT US'
    },
    navigation: {
      home: 'Home',
      history: 'History',
      suppliers: 'Suppliers',
      career: 'Career',
      heating: 'Heating',
      tools: 'Tools'
    },
    contact: {
      email: 'info@empirecanada.ca',
      address: '2320, rue Cohen, Saint-Laurent, QC H4R 2N8'
    },
    allRightsReserved: 'All Rights Reserved'
  },
  history: {
    title: 'Our History',
    loading: 'Loading...',
    fetchError: 'Error loading history',
    foundation: {
      title: 'Foundation',
      text: 'Founded in 1945, Empire Canada began as a small family-owned plumbing supply store in Montreal. Our founders vision was to provide quality products and exceptional service to local contractors and homeowners.'
    },
    growth: {
      title: 'Growth & Evolution',
      text: 'Through decades of dedication and innovation, we expanded our operations across Canada, establishing ourselves as a leading supplier in the plumbing and heating industry.'
    },
    today: {
      title: 'Empire Today',
      text: 'Today, Empire Canada is a nationwide distributor with over 50 locations, serving thousands of professionals and maintaining our commitment to quality and customer service.'
    }
  },
  suppliers: {
    pageTitle: 'Our Suppliers',
    title: 'Our Suppliers',
    supplier1: 'Leading manufacturer of high-quality plumbing fixtures and fittings, known for innovation and reliability.',
    supplier2: 'Specialized in advanced heating solutions and energy-efficient systems.',
    supplier3: 'Premium tool manufacturer with a focus on professional-grade equipment.',
    supplier4: 'Global leader in pipe systems and solutions for various applications.'
  },
  career: {
    title: 'Career Opportunities',
    whyJoin: {
      title: 'Why Join Our Team?',
      benefit1: 'Competitive salary and benefits package',
      benefit2: 'Professional growth and development opportunities',
      benefit3: 'Dynamic and innovative work environment',
      benefit4: 'Work-life balance and flexible schedule'
    },
    openings: {
      title: 'Current Openings',
      position1: {
        title: 'Software Developer',
        description: 'Join our development team to create innovative solutions using cutting-edge technologies.'
      },
      position2: {
        title: 'UX/UI Designer',
        description: 'Help us create beautiful and intuitive user experiences for our digital products.'
      },
      position3: {
        title: 'Product Manager',
        description: 'Lead product strategy and development to deliver exceptional value to our customers.'
      }
    },
    loading: 'Loading...',
    fetchError: 'Error loading careers.',
    apply: 'Apply Now'
  },
  contact: {
    title: 'Contact Us',
    info: {
      title: 'Contact Information'
    },
    email: 'info@empirecanada.ca',
    form: {
      title: 'Send us a Message',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      selectSubject: 'Select a subject',
      subjects: {
        general: 'General Inquiry',
        support: 'Technical Support',
        sales: 'Sales',
        other: 'Other',
        jobApplication: 'Job Application'
      },
      message: 'Message',
      submit: 'Send Message',
      resume: 'Resume/CV',
      chooseFile: 'Choose File',
      noFileChosen: 'No file chosen',
      acceptedFormats: 'Accepted formats: PDF, DOC, DOCX (max 5MB)',
      resumeRequired: 'Please attach your resume',
      invalidFileType: 'Invalid file type. Please upload a PDF or Word document.',
      fileTooLarge: 'File is too large. Maximum size is 5MB.',
      submitSuccess: 'Your message has been sent successfully!',
      submitError: 'There was an error sending your message. Please try again.',
      jobApplicationMessage: 'I would like to apply for the position'
    }
  },
  productDetails: {
    addToCart: 'ADD TO CART',
    shopNow: 'SHOP NOW',
    selectColor: 'Color',
    selectSize: 'Size',
    selectWeight: "Select Weight",
    selectUnit: 'Unit of Measure',
    // eslint-disable-next-line no-dupe-keys
    description: 'DESCRIPTION',
    bestSellers: 'BEST SELLERS',
    addCart: 'ADD CART',
    productName: 'Product Name',
    shippingInfo: 'Shipping Information',
    freeShipping: 'Free shipping on orders over $200.00',
    selectOptions: 'Please select color and size',
    noDescription: 'No technical description available for this product.',
    requiredField: 'This field is required',
    selectRequiredCharacteristics: 'Please select all required characteristics before adding to cart',
    stock: {
      title: 'Stock',
      loading: 'Loading stock information...',
      noLocations: 'No locations available',
      noStock: 'NO STOCK',
      quantityToConfirm: 'Quantity to confirm',
      inventoryToConfirm: 'Inventory to confirm',
      unitsAvailable: '{count} units available',
      unitAvailable: '1 unit available',
      selectLocation: 'Select a location to purchase from',
      quantityExceeded: 'The requested quantity ({requested}) exceeds the available stock ({available}) at the selected location.',
      location1: { title: 'Quebec Les Saules, QC Aisle 17.', subtitle: '80 items available in stock' },
      location2: { title: 'Quebec Les Saules, QC Aisle 17.', subtitle: '80 items available in stock' },
      location3: { title: 'Quebec Les Saules, QC Aisle 17.', subtitle: '80 items available in stock' }
    }
  },
  categoryPage: {
    filters: 'FILTERS',
    clearAll: 'Clear All',
    categories: 'CATEGORIES',
    price: 'PRICE',
    brands: 'BRANDS',
    sortBy: {
      label: 'Sort by',
      featured: 'Sort by Featured',
      priceLowHigh: 'Price: Low to High',
      priceHighLow: 'Price: High to Low',
      nameAZ: 'Name: A to Z',
      nameZA: 'Name: Z to A'
    },
    itemsCount: 'Showing {start} to {end} of {total}',
    previous: 'Previous',
    next: 'Next',
    addToCart: 'ADD TO CART',
    outOfStock: 'Out of Stock',
    noResults: 'No products found',
    showingResults: 'Showing {count} results',
    searchCategories: 'Search categories...',
    showOnlyCategoriesWithProducts: 'Show only categories with products',
    noCategories: 'No categories found',
    branches: 'BRANCHES',
    filterBy: 'FILTER BY',
    searchPlaceholderShort: 'Search',
    noBranches: 'No branches available',
    noAdditionalFilters: 'No additional filters available',
    noBrandsFound: 'No brands found',
    keywords: 'Keywords',
    selectedFilters: 'Selected filters',
    clearFilters: 'Clear all',
    removeFilter: 'Remove filter {name}',
    dynamicFilters: {
      searchPlaceholder: 'Search...',
      noResultsFound: 'No results found',
      noOptionsAvailable: 'No options available',
      showMore: 'Show more',
      showLess: 'Show less'
    },
    onlyInStock: 'Only in stock',
    didYouMean: 'Did you mean',
    noResultsDetailed: 'Search: 0 results found for "{terms}"',
    display: 'Display:',
    resultsCount: '{count} Results'
  },
  myAccount: {
    title: 'My Account',
    orders: 'Orders',
    ordersDescription: 'Track your orders and view purchase history',
    viewOrders: 'View Orders',
    personalInfo: 'Personal Info',
    personalInfoDescription: 'Manage your personal information and contact details',
    editProfile: 'Edit Profile',
    addresses: 'Addresses',
    addressesDescription: 'Manage your delivery addresses',
    manageAddresses: 'Manage Addresses',
    favorites: 'Favorites',
    favoritesDescription: 'View your list of favorite products',
    viewFavorites: 'View Favorites',
    security: 'Security',
    securityDescription: 'Change your password and manage account security',
    managePassword: 'Change Password',
    logout: 'Logout',
    logoutDescription: 'Sign out from the system',
    signOut: 'Sign Out',
    settings: 'System Settings',
    settingsDescription: 'Configure financial data, website content and company information',
    manageSettings: 'Manage Settings'
  },
    systemSettings: {
      title: 'System Settings',
      financial: 'Financial Settings',
      financialDescription: 'Manage financial data, payment methods and tax settings',
      systemMessages: 'System Messages',
      systemMessagesDescription: 'Manage custom messages displayed on the site (checkout, product details)',
      manageSystemMessages: 'Manage Messages',
    manageFinancial: 'Manage financial settings',
    content: 'Website Content',
    contentDescription: 'Configure company history, suppliers and career pages',
    manageContent: 'Manage content',
    company: 'Company Information',
    companyDescription: 'Update company email, address and phone information',
    manageCompany: 'Manage company data',
    users: 'User Settings',
    usersDescription: 'Manage system users, profiles and permissions',
    manageUsers: 'Manage users',
    home: 'Home Page',
    orders: 'Orders Report',
    ordersDescription: 'View and export detailed reports of all orders',
    manageOrders: 'Manage order reports',

    // Category/Product Settings
    categoryProduct: 'Categories and Products',
    categoryProductDescription: 'Manage the visibility of categories and products on the site.',
    manageCategoryProduct: 'Manage Categories and Products',
    searchCategories: 'Search categories...',
    exactSearchTip: 'Use double quotes ("") to search for exact category names',
    searchProducts: 'Search products...',
    showDisabled: 'Show disabled',
    showOnlyWithProducts: 'Show only categories with products',
    noCategories: 'No categories found',
    noProducts: 'No products found in this category',
    noDescription: 'No description',
    enabled: 'Enabled',
    disabled: 'Disabled',
    showProducts: 'View products',
    hideProducts: 'Hide products',
    product: 'Product',
    sku: 'SKU',
    price: 'Price',
    status: 'Status',
    categoryEnabled: 'Category enabled successfully',
    categoryDisabled: 'Category disabled successfully',
    productEnabled: 'Product enabled successfully',
    productDisabled: 'Product disabled successfully',
    errorLoadingCategories: 'Error loading categories',
    errorUpdatingCategory: 'Error updating category',
    errorUpdatingProduct: 'Error updating product',
    noProductsInCategory: 'No products'
  },
  users: {
    searchPlaceholder: 'Search by name or email...',
    allProfiles: 'All Profiles',
    admin: 'Admin',
    manager: 'Manager',
    user: 'User',
    name: 'Name',
    email: 'Email',
    profile: 'Profile',
    actions: 'Actions',
    noUsersFound: 'No users found',
    loadError: 'Error loading users',
    updateSuccess: 'User profile updated successfully',
    updateError: 'Error updating user profile',
    editUser: 'Edit User',
    addUser: 'Add User',
    firstName: 'First Name',
    lastName: 'Last Name',
    password: 'Password',
    firstNamePlaceholder: 'Enter first name',
    lastNamePlaceholder: 'Enter last name',
    emailPlaceholder: 'Enter email address',
    passwordPlaceholder: 'Enter password',
    changePassword: 'Change password',
    selectProfile: 'Select profile',
    fillAllFields: 'Please fill in all required fields',
    createSuccess: 'User created successfully',
    createError: 'Error creating user',
    showing: 'Showing',
    of: 'of',
    items: 'items'
  },

  financial: {
    title: 'Financial Settings',
    currencyCode: 'Currency Code',
    currencyCodePlaceholder: 'Ex: USD, CAD, EUR',
    currencySymbol: 'Currency Symbol',
    currencySymbolPlaceholder: 'Ex: $, €, £',
    taxRate: 'Tax Rate',
    taxRatePlaceholder: 'Enter tax rate in %',
    discountPercentage: 'Discount Percentage',
    discountPercentagePlaceholder: 'Enter discount percentage',
    minOrderValue: 'Minimum Order Value',
    minOrderValuePlaceholder: 'Enter minimum order value',
    freeShippingThreshold: 'Free Shipping Threshold',
    freeShippingThresholdPlaceholder: 'Enter minimum value for free shipping',
    requiredFieldsError: 'Please fill in all required fields',
    updateSuccess: 'Financial settings updated successfully',
    updateError: 'Error updating financial settings',
    loadError: 'Error loading financial settings',
    fieldRequired: 'This field is required',
    shippingCost: 'Shipping Cost',
    shippingCostPlaceholder: 'Enter shipping cost',
    enableAllFields: 'Enable All Fields',
    enableAllFieldsDescription: 'Toggle to enable or disable all fields at once',
    noPermission: 'You do not have permission to edit these settings',
    noPermissionToSave: 'Only administrators can save changes',
    readOnlyMode: 'Read-Only Mode',
    viewOnlyAccess: 'As a manager, you can only view the current settings but cannot modify them.'
  },
  systemMessages: {
    title: 'System Messages',
    loadError: 'Error loading messages',
    updateSuccess: 'Messages updated successfully',
    updateError: 'Error updating messages',
    noPermission: 'You do not have permission to modify these settings',
    readOnlyMode: 'Read-only mode',
    viewOnlyAccess: 'You can only view these settings',
    requiredFieldsError: 'Please fill in all fields in all languages',
    french: 'French',
    english: 'English',
    portuguese: 'Portuguese',
    checkoutPriceDisclaimer: {
      title: 'Price Disclaimer (Checkout)',
      description: 'Message displayed in the Cart section of checkout',
      placeholderFr: 'Les prix présentés sur le site peuvent varier. Le prix final sera validé dans votre confirmation de commande',
      placeholderEn: 'Prices shown on the site may vary. The final price will be validated in your order confirmation',
      placeholderPt: 'Os preços apresentados no site podem variar. O preço final será validado na sua confirmação de pedido'
    },
    productTransferInfo: {
      title: 'Transfer Information (Product Details)',
      description: 'Message displayed on the product details page',
      placeholderFr: 'Pour un transfert d\'une autre succursale, prévoir un délai d\'environs 24 heures. Pour toute urgence, communiquer avec nous.',
      placeholderEn: 'For a transfer from another branch, allow approximately 24 hours. For any urgency, contact us.',
      placeholderPt: 'Para uma transferência de outra filial, prever um prazo de aproximadamente 24 horas. Para qualquer urgência, entre em contato conosco.'
    }
  },
  profile: {
    title: 'Edit Profile',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    firstNamePlaceholder: 'Enter your first name',
    lastNamePlaceholder: 'Enter your last name',
    phonePlaceholder: 'Enter your phone number',
    emailNotEditable: 'Email cannot be edited',
    save: 'Save Changes',
    saving: 'Saving...',
    cancel: 'Cancel',
    fieldRequired: 'This field is required',
    requiredFieldsError: 'Please fill in all required fields',
    updateError: 'Error updating profile. Please try again.',
    updateSuccess: 'Profile updated successfully!'
  },

  ordersSettings: {
    title: 'Orders Report',
    filters: 'Filters',
    dateRange: 'Date Range',
    product: 'Product',
    productPlaceholder: 'Enter product name...',
    city: 'City',
    cityPlaceholder: 'Enter city...',
    projects: 'Projects',
    projectsPlaceholder: 'Select projects...',
    pickupLocation: 'Pickup Location',
    pickupAt: 'Pickup at',
    noLocationSpecified: 'No location specified',
    contactOnSite: 'Contact on Site',
    contactPhone: 'Contact Phone',
    deliveryDate: 'Delivery Date',
    deliveryDateTime: 'Delivery Date',
    specialInstructions: 'Special Delivery Instructions',
    poNumber: 'P.O. Number',
    additionalInfo: 'Additional Info',
    multiselect: {
      selectLabel: 'Press enter to select',
      selectedLabel: 'Selected',
      deselectLabel: 'Press enter to remove',
      noResult: 'No results found',
      noOptions: 'The list is empty',
      noElements: 'No elements found'
    },
    applyFilters: 'Apply Filters',
    resetFilters: 'Reset Filters',
    exportToExcel: 'Export to Excel',
    exporting: 'Exporting...',
    ordersList: 'Orders List',
    sortBy: 'Sort by',
    dateNewest: 'Date: Newest first',
    dateOldest: 'Date: Oldest first',
    totalHighest: 'Amount: Highest to lowest',
    totalLowest: 'Amount: Lowest to highest',
    orderNumber: 'Order Number',
    orderNumberSearch: 'Search by order number',
    orderNumberPlaceholder: 'e.g. 2025- or full number',
    printOrder: 'Print',
    printOrderTitle: 'Open for print or save as PDF',
    printPriceOnRequest: 'On request',
    printDocumentTitle: 'Order',
    printHeading: 'Order summary',
    printSummaryTitle: 'Summary',
    printDeliverySection: 'Delivery & details',
    printFooter: 'Empire Canada — Thank you for your business.',
    printPopupBlocked: 'Please allow pop-ups for this site to print the order.',
    printError: 'Could not load the order for printing.',
    pdfViewerTitle: 'Order',
    downloadPdf: 'Download PDF',
    printPdf: 'Print',
    closePdf: 'Close',
    loadingPdf: 'Loading PDF…',
    pdfLoadError: 'Could not generate the order PDF.',
    customerEmail: 'Customer email',
    customerPhone: 'Customer phone',
    deliveryMethod: 'Fulfillment',
    deliveryMethodDelivery: 'Delivery',
    deliveryMethodPickup: 'Pickup',
    branch: 'Branch',
    noBranch: 'No branch',
    neovationOrder: 'Neovation / reference',
    clientId: 'Client ID',
    productCode: 'Product code',
    date: 'Date',
    project: 'Project',
    total: 'Total',
    status: 'Status',
    actions: 'Actions',
    viewDetails: 'View Details',
    noOrdersFound: 'No orders found',
    previous: 'Previous',
    next: 'Next',
    noProject: 'No project',
    orderDetails: 'Order Details',
    orderInfo: 'Order Information',
    shippingAddress: 'Shipping Address',
    orderItems: 'Order Items',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    totalPrice: 'Total Price',
    color: 'Color',
    size: 'Size',
    weight: 'Weight',
    unit: 'Unit',
    subtotal: 'Subtotal',
    shippingCost: 'Shipping',
    taxAmount: 'Taxes',
    notes: 'Notes',
    status_pending: 'Pending',
    status_processing: 'Processing',
    status_completed: 'Completed',
    status_cancelled: 'Cancelled',
    updateStatus: 'Update Status',
    updateOrderStatus: 'Update Order Status',
    currentStatus: 'Current Status',
    newStatus: 'New Status',
    cancel: 'Cancel',
    updating: 'Updating',
    errorUpdatingStatus: 'Error updating order status',
    excel: {
      fileName: 'Orders_Empire_Canada',
      orderNumber: 'Order Number',
      date: 'Date',
      project: 'Project',
      status: 'Status',
      product: 'Product',
      quantity: 'Quantity',
      unitPrice: 'Unit Price',
      totalPrice: 'Total Price',
      address: 'Address',
      number: 'Number',
      complement: 'Complement',
      neighborhood: 'Neighborhood',
      city: 'City',
      state: 'State/Province',
      postalCode: 'Postal Code',
      country: 'Country',
      shippingCost: 'Shipping',
      taxAmount: 'Taxes',
      orderTotal: 'Order Total',
      notes: 'Notes'
    }
  },
  orders: {
    title: 'My Orders',
    orderNumber: 'Order #{number}',
    noOrders: 'You haven\'t placed any orders yet',
    noOrdersForFilter: 'No orders match this order number.',
    clearOrderFilter: 'Clear filter',
    startShopping: 'Start Shopping',
    fetchError: 'Error loading orders. Please try again.',
    quantity: 'Quantity',
    status: {
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
      cancelled: 'Cancelled'
    },
    shipping: 'Shipping',
    taxes: 'Taxes',
    total: 'Total',
    notes: 'Order Notes',
    noNotes: 'No notes for this order',
    shippingAddress: 'Shipping Address',
    pickupLocation: 'Pickup Location',
    pickupAt: 'Pickup at',
    noLocationSpecified: 'No location specified',
    noShippingAddress: 'No shipping address available',
    landmark: 'Landmark',
    noPriceOrder: 'Order without prices',
    additionalInfo: 'Additional Info',
    project: 'Project',
    projectId: 'Project ID',
    noProject: 'No project associated',
    branch: 'Branch',
    noBranch: 'No branch associated',
    contactOnSite: 'Contact on Site',
    contactPhone: 'Contact Phone',
    deliveryDate: 'Delivery Date',
    deliveryDateTime: 'Delivery Date',
    specialInstructions: 'Special Delivery Instructions',
    poNumber: 'P.O. Number'
  },
  security: {
    title: 'Security',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    updatePassword: 'Update password',
    passwordUpdated: 'Password updated successfully',
    currentPasswordIncorrect: 'Current password is incorrect',
    updateError: 'Error updating password',
    allFieldsRequired: 'All fields are required',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters long'
  },
  company: {
    name: 'Company Name',
    namePlaceholder: 'Enter company name',
    email: 'Email',
    emailPlaceholder: 'Enter company email',
    phone: 'Phone',
    phonePlaceholder: 'Enter company phone',
    website: 'Website',
    websitePlaceholder: 'Enter company website',
    websiteHint: 'Example: www.example.com or https://example.com',
    address: 'Address',
    addressPlaceholder: 'Enter company address',
    loadError: 'Error loading company data',
    updateSuccess: 'Company information updated successfully',
    updateError: 'Error updating company information',
    requiredFieldsError: 'Please fill in all required fields',
    fieldRequired: 'This field is required',
    saving: 'Saving...',
    save: 'Save',
    contacts: {
      sectionTitle: 'Company Contacts',
      title: 'Manage Contacts',
      manage: 'Manage Contacts',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      website: 'Website',
      address: 'Address',
      department: 'Department',
      add: 'Add Contact',
      edit: 'Edit Contact',
      deleteConfirmation: 'Delete Contact',
      deleteWarning: 'This action cannot be undone. Are you sure you want to delete this contact?'
    }
  },
  content: {
    history: {
      title: 'History',
      description: 'Manage company history content, timeline and milestones',
      manage: 'Manage history',
      breadcrumb: 'History',
      form: {
        title: 'Title',
        titlePlaceholder: 'Enter section title...',
        content: 'Content',
        contentPlaceholder: 'Enter section content...',
        year: 'Year',
        yearPlaceholder: 'Enter the year...',
        add: 'ADD SECTION',
        edit: 'EDIT SECTION',
        cancel: 'Cancel'
      },
      actions: {
        hide: 'Hide section',
        show: 'Show section',
        edit: 'Edit section',
        delete: 'Delete section'
      },
      deleteModal: {
        title: "Confirm deletion",
        message: "Are you sure you want to delete this history item? This action cannot be undone.",
        cancel: "Cancel",
        confirm: "Delete"
      },
      messages: {
        addSuccess: 'Section added successfully',
        updateSuccess: 'Section updated successfully',
        deleteSuccess: 'Section deleted successfully',
        visibilitySuccess: 'Section visibility updated successfully',
        loadError: 'Error loading history items',
        addError: 'Error adding section',
        updateError: 'Error updating section',
        deleteError: 'Error deleting section',
        visibilityError: 'Error updating section visibility'
      }
    },
    suppliers: {
      title: "Suppliers",
      description: "Manage supplier content",
      manage: "Manage suppliers",
      breadcrumb: "Suppliers",
      form: {
        title: "Title",
        titlePlaceholder: "Enter title",
        content: "Content",
        contentPlaceholder: "Enter content",
        add: "ADD SECTION",
        edit: "Save changes",
        cancel: "Cancel"
      },
      actions: {
        edit: "Edit item",
        delete: "Delete item",
        show: "Show item",
        hide: "Hide item"
      },
      deleteModal: {
        title: "Delete Supplier Item",
        message: "Are you sure you want to delete this item? This action cannot be undone.",
        confirm: "Delete",
        cancel: "Cancel"
      },
      messages: {
        addSuccess: "Supplier item added successfully",
        updateSuccess: "Supplier item updated successfully",
        deleteSuccess: "Supplier item deleted successfully",
        visibilitySuccess: "Visibility updated successfully",
        loadError: "Failed to load supplier items",
        addError: "Failed to add supplier item",
        updateError: "Failed to update supplier item",
        deleteError: "Failed to delete supplier item",
        visibilityError: "Failed to update visibility"
      }
    },
    career: {
      title: 'Career',
      description: 'Manage job opportunities, requirements and application process',
      manage: 'Manage career',
      breadcrumb: 'Career',
      form: {
        title: 'Job Position',
        titlePlaceholder: 'Enter job position...',
        content: 'Job Description',
        contentPlaceholder: 'Enter job description...',
        add: 'ADD JOB',
        edit: 'EDIT JOB',
        cancel: 'Cancel'
      },
      actions: {
        hide: 'Hide section',
        show: 'Show section',
        edit: 'Edit section',
        delete: 'Delete section'
      },
      modal: {
        deleteTitle: 'Confirm deletion',
        deleteMessage: 'Are you sure you want to delete this career section? This action cannot be undone.',
        cancel: 'Cancel',
        confirm: 'Delete'
      },
      messages: {
        addSuccess: 'Section added successfully',
        updateSuccess: 'Section updated successfully',
        deleteSuccess: 'Section deleted successfully',
        visibilitySuccess: 'Section visibility updated successfully',
        loadError: 'Error loading career items',
        addError: 'Error adding section',
        updateError: 'Error updating section',
        deleteError: 'Error deleting section',
        visibilityError: 'Error updating section visibility'
      }
    }
  },
  addresses: {
    title: 'My Addresses',
    address: 'Address',
    addNew: 'Add New Address',
    street: 'Street',
    streetPlaceholder: 'Enter street name',
    number: 'Number',
    numberPlaceholder: 'Enter number',
    complement: 'Complement',
    complementPlaceholder: 'Enter complement (optional)',
    neighborhood: 'Neighborhood',
    neighborhoodPlaceholder: 'Enter neighborhood',
    city: 'City',
    cityPlaceholder: 'Enter city',
    state: 'State/Province',
    statePlaceholder: 'Enter state or province',
    postalCode: 'Postal Code',
    postalCodePlaceholder: 'Enter postal code',
    setAsDefault: 'Set as default address',
    deleteConfirm: 'Are you sure you want to delete this address?',
    saveSuccess: 'Address saved successfully',
    deleteSuccess: 'Address deleted successfully',
    deleteError: 'Error deleting address',
    error: 'An error occurred. Please try again.',
    default: 'Default',
    requiredField: 'This field is required',
    saveSuccess: 'Addresses saved successfully',
    saveError: 'Error saving addresses',
    loadError: 'Error loading addresses',
    deleteConfirm: 'Are you sure you want to delete this address?',
    deleteSuccess: 'Address deleted successfully',
    deleteError: 'Error deleting address',
    fillAllRequired: 'Please fill in all required fields',
    noAddresses: 'You have no saved addresses',
    deleteModal: {
      title: 'Delete Address',
      message: 'Are you sure you want to delete this address? This action cannot be undone.',
      cancel: 'Cancel',
      confirm: 'Delete'
    }
  },
  accessDenied: {
    title: 'Access Denied',
    message: 'You do not have permission to access this page. This area is restricted to administrators and managers only.',
    goHome: 'Go to Homepage',
    goToAccount: 'Go to My Account'
  },
  pagination: {
    showing: 'Showing',
    of: 'of',
    prev: 'Previous',
    next: 'Next',
    itemsPerPage: 'Items per page'
  },

  breadcrumb: {
    home: 'Home'
  },

  project: {
    selectProject: 'Select a project',
    changeConfirmation: {
      title: 'Change Project',
      message: 'When changing projects, your current cart will be cleared. Do you want to continue?',
      confirm: 'Yes, change project',
      cancel: 'Cancel',
      success: 'Project changed successfully!',
      error: 'Error changing project. Please try again.'
    }
  },
  location: {
    selectLocation: 'Select a branch',
    confirmChange: {
      title: 'Change Branch',
      message: 'You are changing to branch:',
      confirm: 'Yes, change branch',
      cancel: 'Cancel'
    }
  },

  settings: {
    home: {
      title: 'Home Page',
      description: 'Manage the main banner of the home page, including images, titles and colors.',
      manage: 'Manage Banners'
    }
  },

  homeBanner: {
    title: 'Home Page Banners',
    addNew: 'Add New',
    image: 'Image',
    title: 'Title',
    subtitle: 'Subtitle',
    status: 'Status',
    position: 'Position',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    edit: 'Edit',
    delete: 'Delete',
    noBanners: 'No banners found',
    addBanner: 'Add Banner',
    editBanner: 'Edit Banner',
    titleColor: 'Title Color',
    subtitleColor: 'Subtitle Color',
    isActive: 'Banner Active',
    chooseFile: 'Choose File',
    noFileChosen: 'No file chosen',
    imageRequirements: 'Recommended: 1920x1080px, max 2MB, formats: JPG, PNG, GIF, WEBP',
    invalidImageType: 'Invalid file type. Please use JPG, PNG, GIF or WEBP.',
    imageTooLarge: 'Image too large. Maximum size is 2MB.',
    confirmDelete: 'Confirm Deletion',
    deleteWarning: 'Are you sure you want to delete this banner? This action cannot be undone.',
    fetchError: 'Error loading banners. Please try again.',
    saveError: 'Error saving banner. Please try again.',
    deleteError: 'Error deleting banner. Please try again.',
    createSuccess: 'Banner created successfully!',
    updateSuccess: 'Banner updated successfully!',
    deleteSuccess: 'Banner deleted successfully!',
    titlePlaceholderPt: 'Enter title in Portuguese',
    titlePlaceholderEn: 'Enter title in English',
    titlePlaceholderFr: 'Enter title in French',
    subtitlePlaceholderPt: 'Enter subtitle in Portuguese',
    subtitlePlaceholderEn: 'Enter subtitle in English',
    subtitlePlaceholderFr: 'Enter subtitle in French',
    buttonText: 'Button Text',
    buttonTextPlaceholderPt: 'Enter button text in Portuguese',
    buttonTextPlaceholderEn: 'Enter button text in English',
    buttonTextPlaceholderFr: 'Enter button text in French',
    buttonTextHint: 'Leave empty to use default text "Shop Now"',
    buttonLink: 'Button Link',
    buttonLinkPlaceholder: 'Ex: /categories or https://example.com',
    buttonLinkHint: 'Internal link (ex: /categories) or external (ex: https://example.com). Leave empty to use /categories'
  },

  homeTabs: {
    banner: 'Banners',
    logo: 'System Logo',
    brands: 'Brands'
  },

  logo: {
    title: 'System Logo',
    addNew: 'Add New',
    image: 'Image',
    name: 'Name',
    description: 'Description',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    edit: 'Edit',
    delete: 'Delete',
    noLogos: 'No logos found',
    addLogo: 'Add Logo',
    editLogo: 'Edit Logo',
    isActive: 'Logo Active',
    chooseFile: 'Choose File',
    noFileChosen: 'No file chosen',
    imageRequirements: 'Recommended: PNG with transparent background, max 1MB',
    invalidImageType: 'Invalid file type. Please use PNG or SVG.',
    imageTooLarge: 'Image too large. Maximum size is 1MB.',
    confirmDelete: 'Confirm Deletion',
    deleteWarning: 'Are you sure you want to delete this logo? This action cannot be undone.',
    cannotDeleteActive: 'Cannot delete the active logo. Please activate another logo first.',
    cannotDeleteOnly: 'Cannot delete the only logo in the system.',
    fetchError: 'Error loading logos. Please try again.',
    saveError: 'Error saving logo. Please try again.',
    deleteError: 'Error deleting logo. Please try again.',
    createSuccess: 'Logo created successfully!',
    updateSuccess: 'Logo updated successfully!',
    deleteSuccess: 'Logo deleted successfully!',
    activateSuccess: 'Logo activated successfully!',
    activeInfo: 'Only one logo can be active at a time. The active logo will be displayed in the header and footer of the site.',
    firstLogoActive: 'This is the first logo in the system and will be set as active automatically.',
    cannotDeactivateOnly: 'Cannot deactivate the only active logo. At least one logo must be active in the system.'
  },

  brand: {
    title: 'Brands',
    addNew: 'Add New',
    image: 'Image',
    name: 'Name',
    description: 'Description',
    status: 'Status',
    position: 'Position',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    edit: 'Edit',
    delete: 'Delete',
    noBrands: 'No brands found',
    addBrand: 'Add Brand',
    editBrand: 'Edit Brand',
    isActive: 'Brand Active',
    chooseFile: 'Choose File',
    noFileChosen: 'No file chosen',
    imageRequirements: 'Recommended: PNG with transparent background, max 1MB',
    invalidImageType: 'Invalid file type. Please use PNG or SVG.',
    imageTooLarge: 'Image too large. Maximum size is 1MB.',
    confirmDelete: 'Confirm Deletion',
    deleteWarning: 'Are you sure you want to delete this brand? This action cannot be undone.',
    fetchError: 'Error loading brands. Please try again.',
    saveError: 'Error saving brand. Please try again.',
    deleteError: 'Error deleting brand. Please try again.',
    createSuccess: 'Brand created successfully!',
    updateSuccess: 'Brand updated successfully!',
    deleteSuccess: 'Brand deleted successfully!'
  }
}
